import React from 'react';
import { Box } from '@mui/material';
import SectionHeader from './SectionHeader.jsx';

const FormSection = ({
  icon,
  title,
  bgColor = 'grey.50',
  children,
  sx = {
    border: 1,
    borderColor: 'grey.300',
    borderRadius: 2,
    mb: 3,
    overflow: 'hidden',
  },
}) => {
  return (
    <Box sx={sx}>
      <SectionHeader
        icon={icon}
        title={title}
        bgColor={bgColor}
      />
      <Box sx={{ p: 3 }}>
        {children}
      </Box>
    </Box>
  );
};

export default FormSection;